<template functional>
  <component
    :is="$options.components.CommonChip"
    dark
    :class="[
      data.class || '',
      data.staticClass || '',
    ]"
    :color="props.status === 'In Escrow' ? '#9CA88F' : 'grey'"
  >
    {{ props.status === 'Pending' ? 'Listing Pending' : props.status }}
  </component>
</template>

<script lang="ts">
import Vue from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default Vue.extend({
  name: 'AvailabilityTransactionStatusChip',

  components: { CommonChip },

  props: {
    status: {
      type: String,
      required: true
    },
  },
});
</script>
